<template>
  <v-container class="cmp-booking-artists-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <ArtistDetails
        :artist="selectedArtist"
        :main_contact="main_contact"
        @updated="onArtistDetailsUpdated"
        @mc_updated="onMainContactUpdated"
      ></ArtistDetails>
      <glayout
        :tabs="artistSideWindowTabs"
        :loading="selectedArtistData && selectedArtistData.loading"
        :options="[
          {
            text: $t('booking_artist_free_dates'),
            value: 'free_dates',
          },
        ]"
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistData &&
                      selectedArtistData.contact_relations &&
                      selectedArtistData.contact_relations.length
                  )
                "
                :title="$t('related_contacts')"
              >
                <RelatedContacts
                :selectedArtist="selectedArtist"
                :selectedArtistData="selectedArtistData"  />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistData && selectedArtistData.files && selectedArtistData.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedArtistData && selectedArtistData.files"
                  :externalId="artist_id"
                  :externalTable="'artists'"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedArtist && selectedArtist.notes"
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="additional_info">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistData &&
                      selectedArtistData.related_countries &&
                      selectedArtistData.related_countries.length,
                    NTOffsets.WithDBoxBottom + 2
                  )
                "
                :title="$t('country_requs')"
              >
                <RelatedCountries
                  :selectedArtist="selectedArtist"
                  :relatedCountries="selectedArtistData.related_countries"
                  @delete="onCountryDelete"
                />
              </gbox>
              <gbox :title="$t('url')">
                <URLS
                  :selectedArtist="selectedArtist"
                  @changed="onURLsChanged"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistData &&
                      selectedArtistData.related_users &&
                      selectedArtistData.related_users.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('responsible_agents')"
              >
                <RelatedUsers
                  :relatedUsers="selectedArtistData.related_users"
                  :selectedArtist="selectedArtist"
                  @userDelete="onUserDelete"
                />
              </gbox>
              <gbox :title="$t('accounting_infos')">
                <AccountingDefaults
                  :selectedArtist="selectedArtist"
                  @changed="onAccountingDefaultChanged"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="artist_defaults" :title="$t('tab_title_artist_defaults')">
          <grow>
            <gcol>
              <gbox :title="$t('requirements_english')" h="618">
                <Requirements
                  :selectedArtist="selectedArtist"
                  @changed="onSelectedArtistRequirementChange"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('requirements_2nd_language')" h="618">
                <Requirements2nd
                  :selectedArtist="selectedArtist"
                  @changed="onSelectedArtistRequirementChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab
          id="other_defaults"
          :title="$t('tab_title_additional_artist_defaults')"
        >
          <grow>
            <gcol>
              <gbox :title="$t('additional_artist_defaults')" h="438">
                <DBox
                  :id="
                    'cmp-booking-artists-sidewindow-additional_artist_defaults'
                  "
                  :addButton="false"
                >
                  <AdditionalArtistDefault
                    :selectedArtist="selectedArtist"
                    :selectedArtistData="selectedArtistData"
                    @changed="onSelectedArtistRequirementChange"
                  />
                </DBox>
              </gbox>
              <gbox :title="$t('accommodation_info_string')" h="164">
                <AccomodationIndfo
                  :selectedArtist="selectedArtist"
                  :selectedArtistData="selectedArtistData"
                  @changed="onSelectedArtistRequirementChange"
                />
              </gbox>
            </gcol>
            <gcol>
              <!-- :h="
                  boxHeightNamed({
                    rowCount:
                      selectedArtistData.customData &&
                      selectedArtistData.customData.length,
                    min: 1,
                    offset: NTOffsets.WithHeader
                  })
                " -->
              <!-- :h="
                  boxHeight(
                    selectedArtistData &&
                      selectedArtistData.customData &&
                      selectedArtistData.customData.length,
                    5
                  )
                " -->
              <gbox 
                :h="boxHeightNamed({
                  rowCount:selectedArtistData && selectedArtistData.artist_custom_data && selectedArtistData.artist_custom_data.length,
                  min: 1,
                  offset: NTOffsets.WithDBoxBottom,
                  rowHeight:32,
                  max:18,
                  min:1
                })" 
                
                :title="$t('tab_title_custom_fields')"
              >
                <CustomFields
                  :fields="selectedArtistData.artist_custom_data"
                  :section="'booking'"
                  :externalId="selectedArtist.artist_id"
                  :externalTable="'artist'"
                  :module="'booking'"
                  @setData="onsetCustomField"
                  @changed="onCustomDataChanged"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="bookings" :title="$t('tab_title_bookings')">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedArtistData.bookings &&
                      selectedArtistData.bookings.length,
                    min: 1,
                    offset: NTOffsets.WithHeader
                  }) + 42
                "
                :title="$t('bookings')"
              >
                <Bookings
                  :selectedArtistData="selectedArtistData"
                  :selectedArtist="selectedArtist"
                  @filter="onArtistBookingListFilterChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="ical_links" :title="$t('tab_title_ical_web_links')">
          <grow>
            <gcol>
              <gbox :title="$t('info')">
                <Info
                  :selectedArtist="selectedArtist"
                  @changed="onSelectedArtistRequirementChange"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistData &&
                      selectedArtistData.external_links &&
                      selectedArtistData.external_links.length
                  )
                "
                :title="$t('external_calendars')"
              >
                <ExternalCalendars
                  :external_links="selectedArtistData.external_links"
                  @delete="onDeleteExternalLink"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedArtistData &&
                      selectedArtistData.statuses &&
                      selectedArtistData.statuses.length,
                    2
                  )
                "
                :title="$t('booking_status')"
              >
                <BookingStatus
                  :selectedStatuses="selectedStatuses"
                  :selectedArtistData="selectedArtistData"
                  @changed="onBookingStatusSelectionChanged"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('rss_feeds')">
                <DBox
                  :id="'cmp-booking-artists-sidewindow-rss_feed'"
                  :addButton="false"
                >
                  <div class="dt-list">
                    <a
                      class="dt-list-item rss-feed"
                      :href="rssFeed"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ selectedArtist.artist_name }}
                    </a>
                  </div>
                </DBox>
              </gbox>
              <gbox :title="$t('app_section')" h="140">
                <DBox
                  :id="'cmp-booking-artists-sidewindow-app-section'"
                  :addButton="false"
                >
                  <div class="app-section dbox">
                    <div class="dt-list">
                      <div class="dt-list-item">
                        <div class="dt-list-item--body">
                          <div class="dt-list-item--text">
                            {{ $t("show_fees") }}
                          </div>
                        </div>
                        <div class="dt-list-item--options ut-flex">
                          <div class="dt-checkbox v2 s1">
                            <input
                              type="checkbox"
                              :name="'hide_fees'"
                              :id="'hide_fees'"
                              :checked="hideFees"
                              @click="e => onCheckboxChange(e, 'hideFees')"
                            />
                            <div class="checkmark"></div>
                          </div>
                        </div>
                      </div>
                      <div class="dt-list-item">
                        <div class="dt-list-item--body">
                          <div class="dt-list-item--text">
                            {{ $t("display_only_minimum_info") }}
                          </div>
                        </div>
                        <div class="dt-list-item--options ut-flex">
                          <div class="dt-checkbox v2 s1">
                            <input
                              type="checkbox"
                              :name="'display_min'"
                              :id="'display_min'"
                              :checked="displayMin"
                              @click="e => onCheckboxChange(e, 'displayMin')"
                            />
                            <div class="checkmark"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <v-layout
                      mt-4
                      row
                      wrap
                      justify-end
                      class="app-section-bottom"
                    >
                      <button
                        @click="onCreateICalClick"
                        class="dt-button v5 s8"
                      >
                        {{$t('create_ical')}}
                      </button>
                    </v-layout>
                  </div>
                </DBox>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="artist_app" :title="$t('tab_title_artist_app_web_links')">
          <grow>
            <gcol>
              <!-- :h="
                  boxHeightNamed({
                    rowCount:
                      selectedArtistData &&
                      selectedArtistData.statuses &&
                      selectedArtistData.statuses.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                " -->
              <gbox
                :h="
                  boxHeight(
                    selectedArtistData &&
                      selectedArtistData.statuses &&
                      selectedArtistData.statuses.length,
                    2
                  )
                "
                :title="$t('booking_status_links')"
              >
                <BookingStatus
                  :selectedStatuses="selectedStatuses"
                  :selectedArtistData="selectedArtistData"
                  @changed="onBookingStatusSelectionChanged"
                />
              </gbox>
            </gcol>
            <gcol>
              <!-- :h="
                  boxHeight(
                    artistAppWebLink && artistAppWebLink.length,
                    NTOffsets.WithDBoxBottom
                  )
                " -->
              <gbox :title="$t('app_section_links')" h="240">
                <DBox
                  :id="'cmp-booking-artists-sidewindow-app_section_links'"
                  :addButton="false"
                >
                  <div class="app-section dbox">
                    <div class="dt-list">
                      <div
                        class="dt-list-item"
                        v-for="link of artistAppWebLink"
                        :key="link.name"
                      >
                        <div class="dt-list-item--body">
                          <div class="dt-list-item--text">
                            {{ $t(link.tkey) }}
                          </div>
                        </div>
                        <div class="dt-list-item--options ut-flex">
                          <div class="dt-checkbox v2 s1">
                            <input
                              type="checkbox"
                              :name="link.name"
                              :id="link.name"
                              :checked="selectedArtistAppLink.has(link.param)"
                              @click="
                                e => onArtistWebLinkChecked(e, link.param)
                              "
                            />
                            <div class="checkmark"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <v-layout
                      mt-4
                      row
                      wrap
                      justify-end
                      class="app-section-bottom"
                    >
                      <button
                        @click="onCreateArtistAppLink"
                        class="dt-button v5 s8"
                      >
                        {{ $t("create_artist_app_link") }}
                      </button>
                    </v-layout>
                  </div>
                </DBox>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="map">          
          <template #header>
            <grow>
              <gcol>
                <div class="search ut-fh ut-flex" style="max-width: 508px;">
                  <DatePicker2
                    class="shrink-margin"
                    id="from_date"
                    :showLabel="false"
                    :value="selectedArtistData.mapFilters.from_date"
                    @input="onMapFilterDateChange"
                    lw="70px"
                    cw="110px"
                    :hoverStyle="1"
                    :placeholder="$dft.capHead($t('from'))"
                    style="width: 110px"
                  />

                  <DatePicker2
                    class="shrink-margin"
                    id="to_date"
                    style="margin-left: 8px !important; width: 115px"
                    :showLabel="false"
                    :value="selectedArtistData.mapFilters.to_date"
                    @input="onMapFilterDateChange"
                    lw="70px"
                    cw="110px"
                    :hoverStyle="1"
                    :placeholder="$dft.capHead($t('to'))"
                  />

                  <button class="dt-button s8" @click="onSearchMap" style="margin-left: 10px">
                    {{ $dft.capHead($t("search")) }}
                  </button>
                </div>
              </gcol>
              <gcol> </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox :title="$t('google_map')" h="460">
                <Map :selectedArtistData="selectedArtistData" />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <!-- Sidewindow -->

    <ModalContainer :modalKey="'addExternalCalendar'" :width="'small'">
      <QuickModal
        :title="$t('add_new_external_calendar')"
        :forms="externalCalendarForm"
        @cancelled="onModalCancelled"
        @ok="onNewExternalCalendarAdded"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";

import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import QuickModal from "@plugins/quickmodal/quickmodal";

import ArtistDetails from "./artist-details";
import RelatedContacts from "./artist-sidewindow/related-contacts";
import DocumentEditor from "./artist-sidewindow/document-editor";
import RelatedUsers from "./artist-sidewindow/related-users";
import RelatedCountries from "./artist-sidewindow/related-countries";
import URLS from "./artist-sidewindow/urls";
import AccountingDefaults from "./artist-sidewindow/accounting-defaults";
import Requirements from "./artist-sidewindow/requirements";
import Requirements2nd from "./artist-sidewindow/requirements-2nd";
import AdditionalArtistDefault from "./artist-sidewindow/additional-artist-defaults";
import AccomodationIndfo from "./artist-sidewindow/accomodation-info.vue";

import CustomFields from "@/dt-plugins/custom-fields/custom-fields";

import Bookings from "./artist-sidewindow/artist-booking-list";
import Info from "./artist-sidewindow/info";
import BookingStatus from "./artist-sidewindow/booking-status";
import Map from "./artist-sidewindow/map";
import Tracklist from "./artist-sidewindow/tracklist";

import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "../../../../dt-plugins/dbox-files/dbox-files";

import { getGITranslate } from "../../../../plugins/box-widget/models/grid-item.model";
import {
  bookingListCalendarDateTab,
  bookingListCalendarDateTabRoute,
  artistDetailsTabRoute,
  artistLDTRoutes
} from "../../router/router";
import { clientName, HttpClient } from "../../../../services/http/http-client";
import {
  sentenceToSnakeCase,
  createMailHref,
  addRemoveSet,
  sendMail
} from "../../../../utility";
import { ArtistService } from "../../services/artists";

import { checkTabListPermission } from "../../../../router/guard";

import ExternalCalendars from "./artist-sidewindow/external_calendars";
import {
  closeModalRoute,
  createModalMixin
} from "../../../../dt-plugins/modal/modal.mixin";
import {
  createForm,
  createForms
} from "../../../../plugins/form-builder/form.model";
import { getDetailsTabRoutes } from "../../../../utility/route";

const moduleRoute = "booking";
const submenuRoute = "artists";

export default {
  components: {
    ArtistDetails,
    RelatedContacts,
    DocumentEditor,
    RelatedUsers,
    RelatedCountries,
    URLS,
    AccountingDefaults,
    Requirements,
    Requirements2nd,
    AdditionalArtistDefault,
    AccomodationIndfo,
    CustomFields,

    Bookings,

    Info,
    BookingStatus,
    Map,
    Tracklist,

    DBoxTextarea,
    DBoxFiles,
    ModalContainer,
    QuickModal,

    ExternalCalendars
  },
  data: function() {
    return {
      selectedStatuses: new Set(),
      hideFees: true,
      displayMin: true,
      artistAppWebLink: [
        {
          name: "Money Section",
          param: "mos",
          tkey: "money_section"
        },
        {
          name: "Promoter Section",
          param: "prs",
          tkey: "promoter_section"
        },
        {
          name: "Document Section",
          param: "dos",
          tkey: "document_section"
        },
        {
          name: "Feedback Section",
          param: "fes",
          tkey: "feedback_section"
        },
        {
          name: "Guestlist Section",
          param: "gus",
          tkey: "guest_section"
        }
      ],
      selectedArtistAppLink: new Set(["mos", "prs", "dos", "fes", "gus"])
    };
  },
  mixins: [createModalMixin("addExternalCalendar"), createDTGridHost()],
  mounted: function() {
    // this.routeMount();
  },
  watch: {
    selectedArtistData: {
      immediate: true,
      handler: function(to, from) {
        if (to.statuses && to.statuses.length > 0) {
          this.selectedStatuses = new Set(
            to.statuses.map(e => e.booking_status_id)
          );
        }
      }
    }
  },
  computed: {
    ...mapGetters(storeNS, {
      // selectedArtist: "selectedArtist",
      // selectedArtistData: "selectedArtistData",
      selectedArtistLoading: "selectedArtistLoading",
      artistFiles: "artistFiles",
      artistDetails: "artistDetails"
    }),
    artist_id: function() {
      return this.$route.params.artist_id;
    },
    selectedArtistData: function() {
      const defaultData = {
        mapFilters: {
          from_date: "",
          to_date: "",
        }
      }; 

      const selectedArtistDetails =  { ...defaultData, ...(this.artistDetails[this.artist_id] || {}) };
      return {...selectedArtistDetails};
    },
    selectedArtist: function() {
      const sa =  this.selectedArtistData?.artist || {};
      return {...sa};
    },
    rssFeed: function() {
      return `http://detailseu.s3.amazonaws.com/rss/events_confirmed_${clientName}_${sentenceToSnakeCase(
        this.selectedArtist.artist_name
      )}.rss`;
    },
    artistSideWindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("related_contacts")
        },
        {
          route: "additional_info",
          value: this.$t("additional_infos")
        },
        {
          route: "artist_defaults",
          value: this.$t("tab_title_artist_defaults")
        },
        {
          route: "other_defaults",
          value: this.$t("tab_title_additional_artist_defaults")
        },
        {
          route: "bookings",
          value: this.$t("tab_title_bookings")
        },
        {
          route: "ical_links",
          value: this.$t("tab_title_ical_web_links")
        },
        {
          route: "artist_app",
          value: this.$t("tab_title_artist_app_web_links")
        },
        {
          route: "map",
          value: this.$t("tab_title_google_map")
        }
        // {
        //   route: "playlist",
        //   value: this.$t("playlist"),
        //   vgi_id: "tab_title_tracks",
        // },
      ]);
    },

    main_contact: function() {
      return (
        this.selectedArtistData?.contact_relations?.find(
          e => e.contact_id == this.selectedArtist.main_contact_id
        ) || {}
      );
    },

    externalCalendarForm: function() {
      return createForms([
        createForm({
          required: true,
          name: "description",
          showValidationIcons: true
        }),
        createForm({
          required: true,
          name: "external_link",
          showValidationIcons: true
        })
      ]);
    }
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.SELECTED_ARTIST.UPDATE.SINGLE]:
        ActionTypes.SELECTED_ARTIST.UPDATE.SINGLE,
      [ActionTypes.ArtistDetails.UPDATE.SINGLE]:
        ActionTypes.ArtistDetails.UPDATE.SINGLE,
      [ActionTypes.ARTIST_FILES.DELETE.SINGLE]:
        ActionTypes.ARTIST_FILES.DELETE.SINGLE,
      [ActionTypes.ARTIST_RELATED_INFO.DELETE.SINGLE]:
        ActionTypes.ARTIST_RELATED_INFO.DELETE.SINGLE,
      [ActionTypes.ARTIST_RELATED_USER.DELETE.SINGLE]:
        ActionTypes.ARTIST_RELATED_USER.DELETE.SINGLE,
      [ActionTypes.ARTIST_RELATED_COUNTRIES.DELETE.SINGLE]:
        ActionTypes.ARTIST_RELATED_COUNTRIES.DELETE.SINGLE,
      [ActionTypes.UPLOAD_ARTIST_CUSTOM_DATA]:
        ActionTypes.UPLOAD_ARTIST_CUSTOM_DATA,
      [ActionTypes.FILTER_ARTIST_BOOKING_LIST]:
        ActionTypes.FILTER_ARTIST_BOOKING_LIST,
      [ActionTypes.ADD_TRACK]: ActionTypes.ADD_TRACK,
      [ActionTypes.SET_ARTIST_CUSTOM_DATA]: ActionTypes.SET_ARTIST_CUSTOM_DATA,
      [ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE]:
        ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE,
      [ActionTypes.ArtistExternalLinks.SET.ALL]:
        ActionTypes.ArtistExternalLinks.SET.ALL,
      [ActionTypes.ArtistDetailMap.FETCH.MULTIPLE]:
        ActionTypes.ArtistDetailMap.FETCH.MULTIPLE,
      [ActionTypes.UPDATE_SELECTED_ARTIST_DATA]:
        ActionTypes.UPDATE_SELECTED_ARTIST_DATA
    }),

    closeBookingDetails: function(e) {
      this.$emit("closeArtistSidewindow", true);
    },

    onNotesBlur: function(event) {
      // this[ActionTypes.SELECTED_ARTIST.UPDATE.SINGLE]({
      //   item: this.selectedArtist,
      //   name: "notes",
      //   value: event.target.value
      // });

      this[ActionTypes.ArtistDetails.UPDATE.SINGLE]({
        item: this.selectedArtist,
        name: "notes",
        value: event.target.value
      });
    },
    onFileDelete: function(file) {
      console.log("DELETE", file);
      this[ActionTypes.ARTIST_FILES.DELETE.SINGLE](file);
    },
    onDocumentDelete: function(document) {
      console.log(document);
      this[ActionTypes.ARTIST_RELATED_INFO.DELETE.SINGLE]({
        artistInfoId: document.artist_info_id
      });
    },
    onUserDelete: function(user) {
      this[ActionTypes.ARTIST_RELATED_USER.DELETE.SINGLE]({
        // artistId: this.selectedArtist.artist_id,
        userId: user.user_id,
        selectedArtistData: this.selectedArtistData
      });
    },

    onCountryDelete: function(country) {
      console.log(country);
      this[ActionTypes.ARTIST_RELATED_COUNTRIES.DELETE.SINGLE]({
        artistCountryId: country.artist_country_id,
        selectedArtistData: this.selectedArtistData
      });
    },

    onURLsChanged: function({ name, value }) {
      this.dispatchSelectedArtistUpdate(name, value);
    },
    onAccountingDefaultChanged: function({ name, value }) {
      this.dispatchSelectedArtistUpdate(name, value);
    },
    onSelectedArtistRequirementChange: function({ name, value }) {
      this.dispatchSelectedArtistUpdate(name, value);
    },
    dispatchSelectedArtistUpdate: function(name, value) {
      this[ActionTypes.ArtistDetails.UPDATE.SINGLE]({
        item: this.selectedArtist,
        name,
        value
      });
    },
    onCustomDataChanged: function({ name, value, edit }) {
      //console.log("...",payload)
      this[ActionTypes.UPLOAD_ARTIST_CUSTOM_DATA]({
        name,
        value,
        edit,
        item: this.selectedArtist
      });
    },

    onsetCustomField: function(payload) {},

    onArtistBookingListFilterChange: function(filter) {
      console.log(filter);
      this[ActionTypes.FILTER_ARTIST_BOOKING_LIST]({
        ...filter,
        artistId: this.selectedArtist.artist_id
      });
    },
    onBookingStatusSelectionChanged: function(selectedStatuses) {
      this.selectedStatuses = selectedStatuses;
    },
    onCheckboxChange: function(event, prop) {
      this[prop] = event.target.checked;
      // console.log("Log: this[prop]", prop, this[prop]);
    },
    onCreateICalClick: async function() {
      // var icalFlag = 0;
      //     if ( $(domObj).attr('ical_email') )
      //     {
      //         icalFlag = 1;
      //     }
      //     var artist_name = $(domObj).attr('artist_name');
      //     var statuses = '';
      //     var status_arr = [];
      //     $('#[% ical ? 'ical' : 'artist_app' %]_web_link_[% artist.DATA.artist_id %] .booking-status-checkbox:checked').each(function(i,elm){
      //       statuses+= '%26status=' + encodeURIComponent($(elm).val());

      //         var booking_status_id = $(elm).attr('booking_status_id');
      //         status_arr.push( booking_status_id );

      //   //console.log(i +' => val-'+booking_status_id);
      //     });

      // if (!($('#show_fees_[% artist.DATA.artist_id %]').attr('checked'))) {
      //   status_arr.push( -1 );
      // }

      // //console.log('len '+status_arr.length+' jo'+status_arr.join());

      // $.post('booking.pl',{
      //   section: 'artist',
      //   action: 'get_checksum',
      //   artist_id: '[% artist.DATA.artist_id %]',
      //   ical_params:status_arr.join()
      // },function(data){
      //         berlin3.artist.open_ical_email(artist_name, '[% artist.DATA.artist_id %]', data.checksum, data.cal_web_link, statuses, status_arr.join(), icalFlag);
      // },"json");

      // var mailtoHref = "";
      // if ( icalFlag )
      // {
      //     var icalBodyCommon = encodeURIComponent('://ical.' + berlin3.SERVER.replace(/(.*)\.(.*)\.(.*)/i, '$2.$3') + '/artist/' + berlin3.CLIENT + '?section=ical&artist_id='+ artist_id +'&checksum='+ checksum +'&art=' + artist_name.replace(/\W/g, '') + '&status=' + statusStr + '&ical_params=' + statusStr);
      //     var icalG = '%0A%0A' + encodeURIComponent(berlin3.artist.MAIL_BODY_PART2_GOOGLE) + '%0A' + 'https' + icalBodyCommon;
      //     mailtoHref = 'mailto:?Subject=' + encodeURIComponent(berlin3.artist.MAIL_SUBJECT) + '&Body=' + '%0A%0A' + encodeURIComponent(berlin3.artist.MAIL_BODY_PART2) + '%0Awebcal' + icalBodyCommon + icalG;
      // }
      // else {
      //     mailtoHref = 'mailto:?Subject=' + encodeURIComponent(berlin3.artist.MAIL_SUBJECT_ARTIST_APP) + '&Body=' + '%0A%0A' + encodeURIComponent(berlin3.artist.MAIL_BODY_PART5) + '%0A' + encodeURIComponent(cal_web_link + '&status=' + statusStr + '&ical_params=' + statusStr);
      // }

      const baseURL = HttpClient.getBaseURLObject();

      const { artist_name, artist_id } = this.selectedArtist;
      const icalp = [
        ...Array.from(this.selectedStatuses),
        ...(this.displayMin ? ["min"] : []),
        ...(this.hideFees ? [] : [-1])
      ].join(",");

      console.log(this.displayMin, icalp);

      const icalResponse = await ArtistService.createICalLink({
        artistId: this.selectedArtist.artist_id,
        icalParams: icalp
      });

      const calFeed = `ical.${baseURL.domain_tld}/artist/${
        baseURL.client_name
      }?section=ical&artist_id=${artist_id}&checksum=${
        icalResponse.data.checksum
      }&art=${artist_name.replace(
        /\W/g,
        ""
      )}&status=${icalp}&ical_params=${icalp}`;
      const calFeedIcal = `webcal://${calFeed}`;
      const calFeedGoogle = `https://${calFeed}`;

      const ical_mail_body = `
### iCal Feed For iCal and Others ###
${calFeedIcal}

### iCal Feed For Google Calendar ###
${calFeedGoogle}
`;

      sendMail({
        body: ical_mail_body,
        subject: "Your iCal Subscription"
      });
    },
    onArtistWebLinkChecked: function(event, linkParam) {
      console.log(
        "BEFORE CHEKED LINKED",
        this.selectedArtistAppLink,
        linkParam,
        event.target.checked
      );
      this.selectedArtistAppLink = addRemoveSet(
        event.target.checked,
        this.selectedArtistAppLink,
        linkParam
      );
      console.log(
        "AFTER CHEKED LINKED",
        this.selectedArtistAppLink,
        linkParam,
        event.target.checked
      );
    },

    // V1
    // Request URL: dev.berlin3.com/berlin3/booking.pl
    // Request Payload: section=artist&action=get_checksum&artist_id=111&ical_params=87%2C84%2C86%2C85%2C88%2C89%2C81%2Cprs%2Cdos%2Cfes%2Cgus%2C-1
    //Response Payload:https://dev.berlin3.com/artist/berlin3?artist_id=111&checksum=55921654bdf9977b5f8e7abbb61a9b47&section=interface&action=cal
    // Mail Body:https://dev.berlin3.com/artist/berlin3?artist_id=111&checksum=55921654bdf9977b5f8e7abbb61a9b47&section=interface&action=cal&status=87,84,86,85,88,89,81,prs,dos,fes,gus,-1&ical_params=87,84,86,85,88,89,81,prs,dos,fes,gus,-1
    // section=artist&action=get_checksum&artist_id=111&ical_params=87%2C84%2C86%2C85%2C88%2C89%2C81%2Cdos%2Cfes%2Cgus%2C-1
    // V2
    // Request URL: dev.berlin3.com/berlin3/booking.pl
    // Request Payload: section=artist&action=get_checksum&artist_id=111&ical_params=87%2C84%2C86%2C85%2C88%2C89%2C81%2Cmos%2Cprs%2Cdos%2Cfes%2Cgus%2C-1
    // Response Payload:https://dev.berlin3.com/artist/berlin3?artist_id=111&checksum=a5b812772e43b0320759d1fdf54c5bec&section=interface&action=cal
    // Mail Body:https://dev.berlin3.com/artist/berlin3?artist_id=111&checksum=a5b812772e43b0320759d1fdf54c5bec&section=interface&action=cal

    onCreateArtistAppLink: function() {
      const icalp = [
        ...Array.from(this.selectedStatuses),
        ...Array.from(this.selectedArtistAppLink),
        -1
      ].join(",");
      console.log("ICALPS", icalp);
      this.mailLink(icalp);
    },
    mailLink: async function(icalP) {
      const icalResponse = await ArtistService.createICalLink({
        artistId: this.selectedArtist.artist_id,
        icalParams: icalP
      });
      location.href = createMailHref({
        body:
          "### Online App ###\n\n" +
          icalResponse.data.cal_web_link +
          "&status=" +
          icalP +
          "&ical_params=" +
          icalP,
        subject: "Your Artist App Web Link"
      });
    },
    onAddtrack: function() {
      this[ActionTypes.ADD_TRACK]({
        artistId: this.selectedArtist.artist_id
      });
    },
    onArtistDetailsUpdated: function({ name, value }) {
      this[ActionTypes.ArtistDetails.UPDATE.SINGLE]({
        item: this.selectedArtist,
        name,
        value
      });
    },
    onMainContactUpdated: function({ name, value }) {
      this[ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE]({
        selectedArtistData: this.selectedArtistData,
        item: this.main_contact,
        name,
        value
      });
    },
    async onNewExternalCalendarAdded(payload) {
      console.log({ payload: payload });

      const external_linksData = await ArtistService.addExternalCalendarLink({
        artist_id: this.selectedArtist.artist_id,
        ...payload
      });
      this[ActionTypes.ArtistExternalLinks.SET.ALL]({        
        external_links: external_linksData.external_links,
        artist_id: this.artist_id
      });
      this.onModalCancelled();
    },
    async onDeleteExternalLink(item) {
      const external_links = this.selectedArtistData.external_links.filter(
          e => e.external_link_id != item.external_link_id
      );
      this[ActionTypes.ArtistExternalLinks.SET.ALL]({
        external_links,
        artist_id: this.artist_id
      });
      await ArtistService.deleteExternalLink({
        external_link_id: item.external_link_id
      });
    },
    onModalCancelled() {
      closeModalRoute(this);
    },
    onTabOptionClicked(value) {
      switch (value) {
        case 'free_dates':          
        this.$router.push({
            ...this.$route,
            query: {
              modal: "free_dates",
            },
          });          
          break;
      
        default:
          break;
      }
    },
    onMapFilterDateChange: function ({ name, value }) {
      const mapFilters = { ...this.selectedArtistData.mapFilters, [name]: value };
      this[ActionTypes.UPDATE_SELECTED_ARTIST_DATA]({ mapFilters });
    },

    onSearchMap() {
      this[ActionTypes.ArtistDetailMap.FETCH.MULTIPLE]({ artistId: this.artist_id, ...this.selectedArtistData.mapFilters });
    },
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-booking-artists-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 195px);
  }
  .dt-details {
    margin-top: 5px;
  }
  .rss-feed {
    font-weight: 600;
    text-decoration: none;
  }

  .app-section {
    .dt-list .dt-list-item--options {
      min-width: 20px;
    }
    .app-section-bottom {
      position: absolute;
      width: 100%;
      bottom: 10px;
    }
  }
  .tabs-options--panel {
    .dt-button {
      white-space: nowrap;
    }
  }
  // .overview-options {
  //   margin-top: 7%;
  //   .icons {
  //     display: flex;
  //     justify-content: center;
  //     img:first-child {
  //       padding-top: 2px;
  //     }
  //     img {
  //       cursor: pointer;
  //     }
  //     .loading-icon-container {
  //       width: 30px;
  //       .loading-icon {
  //         width: 15px;
  //         height: 15px;
  //         padding-left: 5px;
  //       }
  //     }

  //     .status {
  //       margin-top: 17px;
  //       margin-left: 5px;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
  //         border-radius: 30px;
  //       }
  //     }
  //   }
  // }
}
</style>
